module.exports = __webpack_public_path__ + "static/media/dwellPass-emblem-map-green-shadow-120.70eea146.png";